import React, { useContext, useEffect, useState } from 'react';
import { FormModal } from '../Shared/form';
import { FormContext, FormSchemaFields } from '@sw-sw/lib-form';
import { UIControlType } from '@sw-sw/lib-form-control-types';
import rolesApi from '../../utils/api/roles';

function getSchema(roles: any) {
  return {
    role_id: {
      label: 'Role',
      controlType: UIControlType.select,
      options: roles.map((role: any) => ({
        value: role.id,
        label: role.name,
      })),
      validation: {
        required: true,
      },
    },
    price: {
      label: 'Add a Cost',
      parse: (val: any) => parseFloat(val),
      validation: {
        required: true,
      },
      style: {
        flexBasis: '50%',
      },
    },
    billing_type: {
      label: 'Billing',
      controlType: UIControlType.select,
      options: [
        { value: 'included', label: 'Included' },
        { value: 'on_demand', label: 'On Demand' },
      ],
      validation: {
        required: true,
      },
      style: {
        flexBasis: '50%',
      },
    },
  };
}

export default function AddUserRoleModal({
  isEditAction,
  selectedAddUserModalDetails,
  setUserRolesList,
  setShowUserRoleModal,
  setSelectedAddOnModalDetails,
}: {
  isEditAction: boolean;
  selectedAddUserModalDetails: any;
  setUserRolesList: any;
  setShowUserRoleModal: any;
  setSelectedAddOnModalDetails: any;
}) {
  const formContext = useContext(FormContext);

  const [roles, setRoles] = useState<any>([]);

  useEffect(() => {
    rolesApi.getAllRoles().then((res) => {
      setRoles(res);
    });
  }, []);

  const handleCreate = async (formData: any) => {
    const id = Math.floor(Math.random() * 1000);
    setUserRolesList((prev: any) => [
      ...prev,
      {
        ...formData,
        tempId: id,
        is_enabled: true,
        is_deleted: false,
      },
    ]);
    setShowUserRoleModal(false);
    setSelectedAddOnModalDetails(null);
  };

  const handleEdit = async (formData: any) => {
    setUserRolesList((prev: any) => {
      const updatedList = prev.map((ele: any) => {
        if (
          (ele.id && ele.id === selectedAddUserModalDetails.id) ||
          (ele.tempId && ele.tempId === selectedAddUserModalDetails.tempId)
        ) {
          return {
            ...ele,
            ...formData,
          };
        }
        return ele;
      });
      return updatedList;
    });
    setShowUserRoleModal(false);
    setSelectedAddOnModalDetails(null);
  };

  const handleDelete = async () => {
    setUserRolesList((prev: any) => {
      const updatedList = prev.map((ele: any) => {
        if (
          (ele.id && ele.id === selectedAddUserModalDetails.id) ||
          (ele.tempId && ele.tempId === selectedAddUserModalDetails.tempId)
        ) {
          return {
            ...ele,
            is_deleted: true,
          };
        }
        return ele;
      });
      return updatedList;
    });
    setShowUserRoleModal(false);
    setSelectedAddOnModalDetails(null);
  };

  if (!roles || !roles.length) return null;

  return (
    <FormModal
      modalProps={{
        title: isEditAction ? 'Edit User Role' : 'Create User Role',
      }}
      onSubmit={(formData) =>
        isEditAction ? handleEdit(formData) : handleCreate(formData)
      }
      onCancel={() => {
        setShowUserRoleModal(false);
        setSelectedAddOnModalDetails(null);
      }}
      showDelete={isEditAction ? true : false}
      onDelete={() => handleDelete()}
    >
      <FormSchemaFields
        schema={getSchema(roles)}
        formData={formContext.value}
        onChange={formContext.set}
        initialFormData={isEditAction ? selectedAddUserModalDetails : {}}
      />
    </FormModal>
  );
}
